import * as ambassadorWixEventsScheduleV1ScheduleItem from './events-schedule-v1-schedule-item-schedule.http.js';
import * as ambassadorWixEventsScheduleV1ScheduleItemTypes from './events-schedule-v1-schedule-item-schedule.types.js';
import * as ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes from './events-schedule-v1-schedule-item-schedule.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listScheduleItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.ListScheduleItemsRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.ListScheduleItemsRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.ListScheduleItemsResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.ListScheduleItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.listScheduleItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/schedule',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryScheduleItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.QueryScheduleItemsRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.QueryScheduleItemsRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.QueryScheduleItemsResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.QueryScheduleItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.queryScheduleItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/schedule/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getScheduleItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.GetScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.GetScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.GetScheduleItemResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.GetScheduleItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.getScheduleItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/schedule/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addScheduleItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.AddScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.AddScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.AddScheduleItemResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.AddScheduleItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.addScheduleItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/schedule/draft',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateScheduleItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.UpdateScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.UpdateScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.UpdateScheduleItemResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.UpdateScheduleItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.updateScheduleItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/schedule/draft/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteScheduleItem(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.DeleteScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.DeleteScheduleItemRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.DeleteScheduleItemResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.DeleteScheduleItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.deleteScheduleItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/schedule/draft/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function discardDraft(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.DiscardDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.DiscardDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.DiscardDraftResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.DiscardDraftResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.discardDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/schedule/draft',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDraft(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.PublishDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.PublishDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.PublishDraftResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.PublishDraftResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.publishDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/schedule/publish',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rescheduleDraft(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.RescheduleDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.RescheduleDraftRequest,
  ambassadorWixEventsScheduleV1ScheduleItemUniversalTypes.RescheduleDraftResponse,
  ambassadorWixEventsScheduleV1ScheduleItemTypes.RescheduleDraftResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsScheduleV1ScheduleItem.rescheduleDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/schedule/draft/reschedule',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ScheduleItem as ScheduleItemOriginal,
  TimeInterval as TimeIntervalOriginal,
  ScheduleStatus as ScheduleStatusOriginal,
  ScheduleStatusWithLiterals as ScheduleStatusWithLiteralsOriginal,
  ListScheduleItemsRequest as ListScheduleItemsRequestOriginal,
  StateFilter as StateFilterOriginal,
  StateFilterWithLiterals as StateFilterWithLiteralsOriginal,
  Paging as PagingOriginal,
  ListScheduleItemsResponse as ListScheduleItemsResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryScheduleItemsRequest as QueryScheduleItemsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryScheduleItemsResponse as QueryScheduleItemsResponseOriginal,
  GetScheduleItemRequest as GetScheduleItemRequestOriginal,
  GetScheduleItemResponse as GetScheduleItemResponseOriginal,
  AddScheduleItemRequest as AddScheduleItemRequestOriginal,
  ScheduleItemData as ScheduleItemDataOriginal,
  AddScheduleItemResponse as AddScheduleItemResponseOriginal,
  UpdateScheduleItemRequest as UpdateScheduleItemRequestOriginal,
  UpdateScheduleItemResponse as UpdateScheduleItemResponseOriginal,
  DeleteScheduleItemRequest as DeleteScheduleItemRequestOriginal,
  DeleteScheduleItemResponse as DeleteScheduleItemResponseOriginal,
  DiscardDraftRequest as DiscardDraftRequestOriginal,
  DiscardDraftResponse as DiscardDraftResponseOriginal,
  PublishDraftRequest as PublishDraftRequestOriginal,
  PublishDraftResponse as PublishDraftResponseOriginal,
  RescheduleDraftRequest as RescheduleDraftRequestOriginal,
  RescheduleDraftResponse as RescheduleDraftResponseOriginal,
  ListBookmarksRequest as ListBookmarksRequestOriginal,
  ListBookmarksResponse as ListBookmarksResponseOriginal,
  CreateBookmarkRequest as CreateBookmarkRequestOriginal,
  CreateBookmarkResponse as CreateBookmarkResponseOriginal,
  DeleteBookmarkRequest as DeleteBookmarkRequestOriginal,
  DeleteBookmarkResponse as DeleteBookmarkResponseOriginal,
  QueryScheduleItemsApplicationErrors as QueryScheduleItemsApplicationErrorsOriginal,
} from './events-schedule-v1-schedule-item-schedule.types.js';
